/**
 * Builds multipart FormData from a plain object.
 * Files/Blobs are appended as-is, other values as strings ("true", "3").
 * `undefined` fields are skipped so partial (PATCH) payloads only send what changed.
 */
export const buildFormData = (payload: object): FormData => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(payload)) {
    if (value === undefined) continue;
    formData.append(key, value instanceof Blob ? value : String(value));
  }
  return formData;
};
